/**
 * Stable CSS class names for E2E — Customer information paper (profile edit).
 */
export const CMIP = {
    page: 'customer-information-paper',
    mainGrid: 'customer-information-paper__main-grid',
    columnPersonal: 'customer-information-paper__column-personal',
    inputTextfieldFirstName: 'customer-information-input--textfield-first-name',
    inputTextfieldLastName: 'customer-information-input--textfield-last-name',
    inputTextfieldEmail: 'customer-information-input--textfield-email',
    inputTextfieldBirthday: 'customer-information-input--textfield-birthday',
    columnActions: 'customer-information-paper__column-actions',
    actionsTopRow: 'customer-information-paper__actions-top-row',
    blockPhoneUpdate: 'customer-information-paper__block-phone-update',
    inputButtonSendPhoneMail: 'customer-information-input--button-send-phone-mail',
    blockCredentialReset: 'customer-information-paper-block-reset',
    inputButtonCredentialResetSms: 'customer-information-input--button-reset-sms',
    mailSentNotice: 'customer-information-paper__mail-sent-notice',
    fieldCustomerType: 'customer-information-field--customer-type',
    inputRadioGroupCustomerType: 'customer-information-input--radio-group-customer-type',
    inputButtonUpdateCustomer: 'customer-information-input--button-update-customer',
} as const;

export const cmipCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
